export const environment = {
  api: 'https://api.club-administration.qa.qubika.com/api',
  production: true,
  appVersion: '0.0.1'
};
